import { Activity } from "lucide-react";

export const BrandMark = ({ light = false, compact = false }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-mark">
    <div className="h-9 w-9 rounded-lg bg-sky-600 grid place-items-center shadow-sm">
      <Activity className="h-5 w-5 text-white" strokeWidth={2.5} />
    </div>
    {!compact && (
      <div className="leading-tight">
        <div className={`font-heading font-extrabold text-[15px] tracking-tight ${light ? "text-white" : "text-slate-900"}`}>
          Upkar Healthcare
        </div>
        <div className={`text-[10px] uppercase tracking-[0.18em] ${light ? "text-slate-400" : "text-slate-500"}`}>
          India Pvt. Ltd.
        </div>
      </div>
    )}
  </div>
);
